import React, { useEffect, useState } from 'react';
import { Typography, Box, Paper, Button, Container, Divider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { PRESENTATION_RESOURCES } from './PresentationResources';
import FlowerTable from '../Tree/components/ThreeFlowers';
import COLORS, { appTheme } from '../Tree/constants/theme';


function PresentationPage() {
  const [presentationData, setPresentationData] = useState(null);
  useEffect(() => {
    if (presentationData) {
      let pageTitle = PRESENTATION_RESOURCES.header.title;
      if (presentationData.tutorName && presentationData.client !== 'Demo') {
        pageTitle += ` - ${presentationData.tutorName}`;
      }
      document.title = pageTitle;
    }
  }, [presentationData]);
  useEffect(() => {
    const storedData = sessionStorage.getItem('presentationData');
    if (storedData) {
      const data = JSON.parse(storedData);
      setPresentationData(data);
    }
  }, []);

  const handleBrowserPDF = async () => {
    try {
      const pdfStyles = document.createElement('style');
      pdfStyles.id = 'pdf-optimization';
      pdfStyles.textContent = `
      @media print {
        @page { 
          size: A4 landscape; 
          margin: 0.5in;
          margin-top: 0.3in;
          margin-bottom: 0.3in;
        }
        
        /* Hide browser default headers and footers */
        @page :first { margin-top: 0; }
        @page :left { margin-left: 0.3in; }
        @page :right { margin-right: 0.3in; }
        
        * { 
          -webkit-print-color-adjust: exact !important; 
          color-adjust: exact !important; 
        }
        
        .no-print { display: none !important; }
        body { 
          font-size: 10pt; 
          line-height: 1.3;
          margin: 0 !important;
          padding: 0 !important;
        }
        
        html {
          overflow: visible !important;
        }
        
        /* Force page breaks for intro pages */
        .intro-page {
          page-break-after: always !important;
          page-break-inside: avoid !important;
        }
        
        /* Don't add page break after the last intro page */
        .intro-page:last-of-type {
          page-break-after: auto !important;
        }
        
        /* Force content to start from top */
        .MuiContainer-root {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
          max-width: 100% !important;
          margin: 0 !important;
        }
        
        .MuiPaper-root {
          padding: 20px !important;
          min-height: auto !important;
          box-shadow: none !important;
        }
        
        /* Remove extra margins and padding */
        .MuiBox-root {
          margin-bottom: 5px !important;
        }
        
        /* Reduce header spacing */
        .MuiBox-root[style*="textAlign: left"] h4,
        .MuiBox-root[style*="textAlign: left"] h5 {
          margin-bottom: 5px !important;
        }
        
        /* Reduce spacing in main content wrapper */
        .MuiBox-root[style*="mb: 4"] {
          margin-bottom: 5px !important;
        }
        
        .MuiPaper-elevation2 {
          padding: 10px !important;
          margin-bottom: 0 !important;
        }
        
        /* Reduce gap in flex containers */
        .MuiBox-root[style*="gap: 3"] {
          gap: 15px !important;
        }
        
        /* Reduce title margins */
        h5[style*="mb: 3"] {
          margin-bottom: 10px !important;
        }
        
        /* Reduce paragraph spacing */
        .MuiTypography-body1 {
          margin-bottom: 5px !important;
        }
        
        ul {
          margin-top: 5px !important;
          margin-bottom: 5px !important;
        }
        
        /* Maintain flex layout in print */
        .MuiBox-root {
          page-break-inside: avoid;
          page-break-before: avoid;
        }
        
        /* Prevent page breaks within content sections */
        .MuiPaper-elevation2 {
          page-break-inside: avoid !important;
        }
        
        /* Keep header with content */
        h4, h5, h6 {
          page-break-after: avoid !important;
          page-break-inside: avoid !important;
        }
        
        /* Ensure flex containers stay side-by-side */
        [style*="display: flex"] {
          display: flex !important;
          flex-wrap: nowrap !important;
        }
        
        /* Keep the tree and text side by side */
        [style*="flex: 1 1 300px"] {
          flex: 1 1 45% !important;
          min-width: 45% !important;
          max-width: 400px !important;
        }
        
        /* For introduction mode with sample tree */
        .intro-page [style*="flex: 1 1 300px"] img[src="SampleTree.png"] {
          max-width: 400px !important;
          width: auto !important;
          height: auto !important;
          max-height: 350px !important;
        }
        
        [style*="flex: 1 1 400px"] {
          flex: 1 1 45% !important;
          min-width: 45% !important;
          max-width: 48% !important;
        }
        
        /* For compare mode with two trees */
        [style*="flex: 1 1 500px"] {
          flex: 1 1 58% !important;
          min-width: 58% !important;
          max-width: 60% !important;
        }
        
        [style*="flex: 1 1 350px"] {
          flex: 1 1 38% !important;
          min-width: 38% !important;
          max-width: 40% !important;
        }
        
        /* Adjust image sizes for print */
        img {
          max-width: 100% !important;
          height: auto !important;
          max-height: 280px !important;
          page-break-inside: avoid;
        }
        
        /* Keep FlowerTable with tree image */
        .MuiBox-root[style*="backgroundColor: #f9f9f9"] {
          page-break-before: avoid !important;
          page-break-after: avoid !important;
          page-break-inside: avoid !important;
          margin-top: 8px !important;
          padding: 8px !important;
        }
        
        /* Reduce spacing in content sections */
        .MuiBox-root[style*="flex: 1 1"] {
          margin-bottom: 0 !important;
        }
        
        /* Adjust font sizes for print */
        h5 {
          font-size: 14pt !important;
        }
        
        h6 {
          font-size: 12pt !important;
        }
        
        .MuiTypography-body1 {
          font-size: 10pt !important;
          line-height: 1.3 !important;
        }
        
        ul {
          margin-top: 5px !important;
          margin-bottom: 5px !important;
        }
        
        li {
          margin-bottom: 3px !important;
        }
      }
    `;
      document.head.appendChild(pdfStyles);
      setTimeout(() => {
        window.print();
        setTimeout(() => {
          if (document.head.contains(pdfStyles)) {
            document.head.removeChild(pdfStyles);
          }
        }, 1000);
      }, 100);
    } catch (error) {
      console.error('Browser PDF error:', error);
    }
  };

  const formatDisplayDate = (timestamp) => {
    if (!timestamp) return 'Unknown Date';
    const date = new Date(timestamp);
    const options = { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  };



  const renderContent = () => {
    if (!presentationData) return null;

    if (presentationData.mode === 'introduction') {
      return (
        <>
          {PRESENTATION_RESOURCES.tabs.introduction.pages.map((page, pageIndex) => (
            <Box
              key={pageIndex}
              elevation={2}
              className="intro-page"
              sx={{
                p: 3,
                mb: pageIndex < PRESENTATION_RESOURCES.tabs.introduction.pages.length - 1 ? 4 : 0,
                sx: { backgroundColor: PRESENTATION_RESOURCES.styles.pageBackground },
                '@media screen': {
                  minHeight: 'auto'
                }
              }}
            >
              <Box >
                <Typography 
                  variant="h1" 
                  gutterBottom 
                  sx={{ 
                    textAlign: 'left', 
                    mb: 3,
                    fontSize: '1.5rem',
                    fontWeight: 600,
                  }}
                >
                  {pageIndex === 0 ? PRESENTATION_RESOURCES.tabs.introduction.title : ''}
                </Typography>

                <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                  {/* Sample Tree Image */}
                  {page.content.showSampleTree && (
                    <Box sx={{ flex: '1 1 300px', minWidth: '0', maxWidth: '400px', textAlign: 'center', width: '100%', overflow: 'hidden' }}>
                      <Typography 
                        variant="subtitle1" 
                        component="h6"
                        gutterBottom
                        sx={{
                          fontSize: '1rem',
                          fontWeight: 600
                        }}
                      >
                        Sample Talk Tree
                      </Typography>
                      <img
                        src="SampleTree.png"
                        alt="Talk Tree Illustration"
                        style={{
                          width: '100%',
                          height: 'auto',
                          maxWidth: '400px',
                          maxHeight: '350px',
                          transform: 'scale(0.8)',
                          transformOrigin: 'top center',
                        }}
                      />
                      <FlowerTable isPresentationPage={true} />
                    </Box>
                  )}

                  {/* Content */}
                  <Box sx={{ flex: '1 1 400px', textAlign: 'left' }}>
                    <Typography 
                      variant="h2" 
                      gutterBottom
                      sx={{
                        fontSize: '1.25rem',
                        fontWeight: 600
                      }}
                    >
                      {page.content.heading}
                    </Typography>

                    {page.content.description.length > 0 && (
                      <Typography 
                        variant="body1" 
                        paragraph
                        sx={{
                          fontSize: '1rem',
                          fontWeight: 400
                        }}
                      >
                        {page.content.description}
                      </Typography>
                    )}

                    <ul style={{ marginLeft: '18px', marginTop: '10px' }}>
                      {page.content.pointList.map((item, index) => (
                        <li key={index}>
                          <Typography 
                            variant="body1" 
                            sx={{ 
                              fontSize: '1rem',
                              fontWeight: 400,
                              lineHeight: 1.5, 
                              mb: 1 
                            }}
                          >
                            {item}
                          </Typography>
                        </li>
                      ))}
                    </ul>
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </>
      );
    } else if (presentationData.mode === 'celebrate' && presentationData.selectedTree) {
      const tree = presentationData.selectedTree;
      return (
        <Box>
          <Typography 
            variant="h1" 
            gutterBottom 
            sx={{ 
              textAlign: 'left', 
              mb: 3,
              fontSize: '1.5rem',
              fontWeight: 600
            }}
          >
            {PRESENTATION_RESOURCES.tabs.celebrate.title}
          </Typography>

          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'flex-start' }}>
            {/* Tree Image */}
            <Box sx={{ flex: '1 1 300px', minWidth: '0', textAlign: 'center', width: '100%' }}>
              <Typography 
                variant="subtitle1" 
                component="h6"
                gutterBottom
                sx={{
                  fontSize: '1rem',
                  fontWeight: 600
                }}
              >
                {formatDisplayDate(tree.startTime)}
              </Typography>
              {tree.image ? (
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  p: 2,
                  backgroundColor: 'white',
                  borderRadius: 2,
                  border: '1px solid #e0e0e0'
                }}>
                  <img
                    src={tree.image}
                    alt="Talk Tree"
                    style={{
                      transform: 'scale(0.8)',
                      height: 'auto',
                    }}
                  />
                </Box>
              ) : (
                <Box sx={{
                  height: 200,
                  backgroundColor: '#fff3e0',
                  border: '2px dashed #ff9800',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: 2
                }}>
                  <Typography 
                    variant="body1" 
                    color="text.secondary"
                    sx={{
                      fontSize: '1rem',
                      fontWeight: 400
                    }}
                  >
                    Tree image not available
                  </Typography>
                </Box>
              )}
              <FlowerTable isPresentationPage={true} />

            </Box>

            {/* Conversation Starters */}
            <Box sx={{ flex: '1 1 400px', textAlign: 'left' }}>
              <Typography 
                variant="h2" 
                gutterBottom
                sx={{
                  fontSize: '1.25rem',
                  fontWeight: 600
                }}
              >
                {PRESENTATION_RESOURCES.tabs.celebrate.conversationStarterTitle}
              </Typography>
              <ul style={{ marginLeft: '18px', marginTop: '10px' }}>
                {presentationData.selectedStarters?.map((starter, index) => (
                  <li key={index}>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        fontSize: '1rem',
                        fontWeight: 400,
                        lineHeight: 1.5, 
                        mb: 1 
                      }}
                    >
                      {starter}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Box>
          </Box>
        </Box>
      );
    } else if (presentationData.mode === 'compare' && presentationData.selectedTrees) {
      return (
        <Box>
          <Typography 
            variant="h1" 
            gutterBottom 
            sx={{ 
              textAlign: 'left', 
              mb: 3,
              fontSize: '1.5rem',
              fontWeight: 600
            }}
          >
            {PRESENTATION_RESOURCES.tabs.compare.title}
          </Typography>

          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'flex-start' }}>
            {/* Tree Images Side by Side */}
            <Box sx={{ flex: '1 1 500px', minWidth: '300px' }}>
              <Box sx={{
                display: 'flex',
                gap: 2,
                justifyContent: 'center',
                flexWrap: 'wrap'
              }}>
                {presentationData.selectedTrees.map((tree, index) => (
                  <Box key={tree.sessionId} sx={{
                    flex: '1 1 200px',
                    minWidth: '200px',
                    maxWidth: '300px',
                    textAlign: 'center'
                  }}>
                    <Typography 
                      variant="subtitle1" 
                      component="h6"
                      gutterBottom 
                      sx={{ 
                        fontSize: '1rem',
                        fontWeight: 600
                      }}
                    >
                      {formatDisplayDate(tree.startTime)}
                    </Typography>
                    {tree.image ? (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'center',
                          transform: {
                            xs: 'scale(0.5)',
                            sm: 'scale(0.6)',
                            md: 'scale(0.7)',
                            lg: 'scale(0.8)',
                          },
                          transformOrigin: 'top center',
                        }}
                      >
                        <img
                          src={tree.image}
                          alt={`Talk Tree ${index + 1}`}
                          style={{
                            height: 'auto',
                            display: 'block',
                          }}
                        />
                      </Box>
                    ) : (
                      <Box sx={{
                        height: 200,
                        backgroundColor: '#fff3e0',
                        border: '2px dashed #ff9800',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 2
                      }}>
                        <Typography 
                          variant="body1" 
                          color="text.secondary"
                          sx={{
                            fontSize: '1rem',
                            fontWeight: 400
                          }}
                        >
                          Tree image not available
                        </Typography>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
              <FlowerTable isPresentationPage={true} />
            </Box>

            {/* Conversation Starters */}
            <Box sx={{ flex: '1 1 350px', textAlign: 'left' }}>
              <Typography 
                variant="h2" 
                gutterBottom
                sx={{
                  fontSize: '1.25rem',
                  fontWeight: 600
                }}
              >
                {PRESENTATION_RESOURCES.tabs.compare.conversationStarterTitle}
              </Typography>
              <ul style={{ marginLeft: '18px', marginTop: '10px' }}>
                {presentationData.selectedStarters?.map((starter, index) => (
                  <li key={index}>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        fontSize: '1rem',
                        fontWeight: 400,
                        lineHeight: 1.5, 
                        mb: 1 
                      }}
                    >
                      {starter}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Box>
          </Box>
        </Box>
      );
    }

    return (
      <Box sx={{
        height: 300,
        backgroundColor: '#fff3e0',
        border: '2px dashed #ff9800',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 2
      }}>
        <Typography 
          variant="subtitle1" 
          component="h6"
          color="text.secondary"
          sx={{
            fontSize: '1rem',
            fontWeight: 400
          }}
        >
          No content available
        </Typography>
      </Box>
    );
  };

  if (!presentationData) {
    return (
      <ThemeProvider theme={appTheme}>
        <Container maxWidth="md" sx={{ mt: 4 }}>
          <Typography 
            variant="h5"
            sx={{
              fontSize: '1.25rem',
              fontWeight: 600
            }}
          >
            Loading presentation...
          </Typography>
        </Container>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={appTheme}>
      <Container 
        maxWidth="lg" 
        sx={{ 
          py: 4,
          backgroundColor: PRESENTATION_RESOURCES.styles.pageBackground,
          minHeight: "100vh", 
        }}
      >
        <Paper elevation={0} sx={{ p: 4, minHeight: '100vh' }} data-pdf-content>
          {/* Header */}
          <Box sx={{ textAlign: 'left', mb: 4, '@media print': { mb: 2 } }}>
            <Typography 
              variant="h1" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1.625rem',
                color: '#000',
                textAlign: 'left',
                
              }}
            >
              {PRESENTATION_RESOURCES.header.title}
            </Typography>
            {presentationData.client !== 'Demo' && (
              <Typography 
                variant="body1" 
                color="text.secondary" 
                gutterBottom 
                sx={{ 
                  mt: 1,
                  fontSize: '1rem',
                  fontWeight: 400
                }}
              >
                {`Tutor Name: ${presentationData.tutorName}`}
              </Typography>
            )}
          </Box>

          {/* Main Content Section */}
          <Box sx={{ mb: 4 }}>
            {presentationData.mode === 'introduction' ? (
              renderContent()
            ) : (
              <Paper elevation={2} sx={{ p: 3, mb: 4 }}>
                {renderContent()}
              </Paper>
            )}
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: 2,
            mt: 4,
            '@media print': { display: 'none' }
          }} className="no-print">
            <Button
              variant="contained"
              onClick={handleBrowserPDF}
              sx={{ 
                backgroundColor: COLORS.primaryDark,
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                padding: '8px 20px',
                fontSize: '14px',
                fontWeight: 700,
                textTransform: 'none',
                lineHeight: 1,
                whiteSpace: 'nowrap',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: COLORS.primaryDarkHover,
                  boxShadow: 'none'
                } 
              }}
            >
              Save as PDF
            </Button>
          </Box>
        </Paper>
      </Container>
    </ThemeProvider>
  );
}

export default PresentationPage;